import { Box, Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, VStack } from "@chakra-ui/react";

import { $count, $isstring, $length, $string } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";
import { $map } from "foundation-ts/array";

import { ModalWindowState } from "@components/Modals/ModalConstants";

export const DefaultAsyncSelectModalState:AsyncSelectModalState = {
    items: null,
    onClose: async () => {},
    onSelect: async (_index:number) => {},
} ;

export interface AsyncSelectItem {
    label: string;
    labelDesc?: string;
    complement1?: string;
    complement2?: string;
    color: string;
    bg: string;
    hover: {
        color: string;
        bg: string; 
    } ;
    selected: {
        color: string;
        bg: string;
    }
}

export interface AsyncSelectModalState extends ModalWindowState {
    items: Nullable<Array<AsyncSelectItem|string>> ;
    onSelect: (index:number) => Promise<void>;
}

const DefaultItemColor = "white" ;
const DefaultItemBgColor = "blue.600" ;
export const AsyncSelectModal = (props: AsyncSelectModalState) => {
    const { onClose, items, title, message, onSelect, size = 'md' } = props ;

    return (
        <Modal onClose={onClose} size={size} isOpen={$count(items)>0} closeOnEsc={true} isCentered={true}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{$string(title)}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>{$string(message)}</ModalBody>
                <VStack>                    
                    { $map(items, (item, index) => {
                        const iss = $isstring(item) ;
                        const label = iss ? item as string : (item as AsyncSelectItem).label ;
                        const labelDesc = iss || !$length((item as AsyncSelectItem).labelDesc) ? '' : (item as AsyncSelectItem).labelDesc;
                        const complement1 = iss || !$length((item as AsyncSelectItem).complement1) ? '' : (item as AsyncSelectItem).complement1! ;
                        const complement2 = iss || !$length((item as AsyncSelectItem).complement2) ? '' : (item as AsyncSelectItem).complement2! ;
                        const color = iss || !$length((item as AsyncSelectItem).color) ? DefaultItemColor : (item as AsyncSelectItem).color! ;
                        const bgColor = iss || !$length((item as AsyncSelectItem).bg) ? DefaultItemBgColor : (item as AsyncSelectItem).bg! ;
                        const hoverColor = iss || !$length((item as AsyncSelectItem).hover.color) ? DefaultItemColor : (item as AsyncSelectItem).hover.color! ;
                        const hoverBgColor = iss || !$length((item as AsyncSelectItem).hover.bg) ? DefaultItemBgColor : (item as AsyncSelectItem).hover.bg! ;
                        const selectedColor = iss || !$length((item as AsyncSelectItem).selected.color) ? DefaultItemColor : (item as AsyncSelectItem).selected.color! ;
                        const selectedBgColor = iss || !$length((item as AsyncSelectItem).selected.bg) ? DefaultItemBgColor : (item as AsyncSelectItem).selected.bg! ;
                        return (
                            <Box as="button" key={index}
                                 p="2"
                                 width="100%"
                                 minH="3em"
                                 color={color}
                                 bg={bgColor}
                                 _hover={{ bg:hoverBgColor, color:hoverColor }}
                                 _focus={{ bg:selectedBgColor, color:selectedColor }}
                                 onClick={async () => onSelect(index)}
                            >
                                <Flex direction="column" overflow="hidden" width="100%" align="stretch">
                                    <Box textAlign="left" as="h4" fontWeight="bold">
                                        <span color={color}>{label}</span>
                                    </Box>
                                    {$length(labelDesc) > 0 && (
                                        <Box textAlign="left" fontSize="small" mt={0}>
                                            {labelDesc}
                                        </Box>
                                    )}
                                    {$length(complement1) > 0 && (
                                        <Box textAlign="left" as="p" fontWeight="100" fontSize="small" mt={3}>
                                            <span>{complement1}</span>
                                        </Box>
                                    )}
                                    {$length(complement2) > 0 && (
                                        <Box textAlign="left" as="p" fontWeight="100" fontSize="small" mt={$length(complement1) > 0 ? 0 : 3}>
                                            <span>{complement2}</span>
                                        </Box>
                                    )}
                                </Flex>
                            </Box>
                        )
                    })}
                </VStack>
                <ModalFooter margin="auto"></ModalFooter>
            </ModalContent>
        </Modal>
    ) ;
} ;